/**
 * Created by BETALOS on 14/10/2016. Edited by amine on 04/10/2018
 */
(function () {

    'use strict';

    const SELECTED_CATALOG_KEY = "visit_procedure_catalog";

    class VisitFinancialCtrl {
        constructor($mdDialog, $translate, visitService, catalogService, $q, $element, $timeout, paymentService, $scope, configService, warehouseService) {
            this.dialog = $mdDialog;
            this.translate = $translate;
            this.visitService = visitService;
            this.catalogService = catalogService;
            this.$q = $q;
            this.$element = $element;
            this.$timeout = $timeout;
            this.paymentService = paymentService;
            this.warehouseService = warehouseService;
            this.$scope = $scope;

            this.advanceForm = configService.hasAdvanceVisitFinancial();
        }

        static get $inject() {
            return [
                "$mdDialog", "$translate", "visitService", "catalogService", "$q", "$element", "$timeout", "paymentService", "$scope",
                "configService", "warehouseService"
            ];
        }

        $onInit() {
            this.visitInstance = null;
            this.visit = this.visit || null;
            this.promise = this.visitService.getVisit(this.visit).then(data => {
                this.visitInstance = data;
            });
        }

        cancel() {
            this.dialog.cancel();
        }

        total(net = false) {
            const deliveryDocumentTaxedTotal = _.get(this.visitInstance, "delivery_document.taxed_total", 0);
            const globalDiscount = _.get(this.visitInstance, "financial_status.global_discount", 0);

            const proceduresTotal = _.reduce(_.get(this.visitInstance, "procedures", []), (result, item) => {
                return result + item['qte'] * (item['price'] - item['discount']);
            }, 0);

            const grossTotal = proceduresTotal + deliveryDocumentTaxedTotal;

            return net ? grossTotal - globalDiscount : grossTotal;
        }

        procedureDiscountChange(item, field) {
            switch (field) {
                case "line":
                    item.total_discount = item.discount * item.qte;
                    break;
                default:
                    item.discount = item.total_discount / item.qte;
                    break;
            }
        }

        prePrint() {
            return this.visitService.updateVisit(this.visitInstance, ['procedures', 'financial_status']);
        }

        emptyVisitDetail(ev) {
            let confirm = this.dialog.confirm()
                .multiple(true)
                .targetEvent(ev)
                .ariaLabel('empty visit financial warning')
                .ok(this.translate.instant('confirm'))
                .cancel(this.translate.instant('cancel'))
                .title(this.translate.instant('empty_financial_confirm_msg'));

            this.dialog.show(confirm).then(() => {
                this.visitProcedures = [];
                if (this.advanceForm) this.visitInstance.delivery_document.lines = [];
            });
        }

        save() {
            if (this.visitInstance.financial_status.is_validated < this.visitInstance.financial_status.paid_amount) {
                const alert = this.dialog.alert()
                    .parent(this.$element)
                    .clickOutsideToClose(true)
                    .multiple(true)
                    .title('')
                    .htmlContent(this.translate.instant('visit_financial_alert_msg'))
                    .ariaLabel('confirm')
                    .ok(this.translate.instant('ok'));

                this.dialog.show(alert);
            } else {
                this.dialog.hide(this.visitInstance);
            }
        }
    }

    module.exports = {
        multiple: true,
        controllerAs: "vm",
        controller: VisitFinancialCtrl,
        template: require("../views/visit-financial.tpl.html"),
        parent: $(document.body),
        clickOutsideToClose: false,
        bindToController: true
    };
})();

